import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrupoUsuarioList() {
  // Use toast
  const toast = useToast()

  const refTabelaPrecoItemTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: '#' },
    { key: 'item_nome', sortable: true, label: 'Produto' },
    { key: 'preco_venda', sortable: true, label: 'Preço Venda' },
    { key: 'data_inclusao', sortable: true, label: 'Data Criação' },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(10)
  const totalTabelaPreco = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 15, 20, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('data_inclusao')
  const isSortDirDesc = ref(false)
  const idTabelaPrecoFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refTabelaPrecoItemTable.value ? refTabelaPrecoItemTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTabelaPreco.value,
    }
  })

  const refetchData = () => {
    refTabelaPrecoItemTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, idTabelaPrecoFilter], () => {
    refetchData()
  })

  const findAllTabelaPreco = (ctx, callback) => {
    store
      .dispatch('appAdmTabelaPrecoItem/findAll', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        idTabelaPrecoFilter: idTabelaPrecoFilter.value,
      })
      .then(response => {
        const { tabela_precos_itens, total } = response.data

        callback(tabela_precos_itens)
        totalTabelaPreco.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching tabela precos list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'Admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === null) return 'warning'
    if (status === 1) return 'success'
    if (status === 0) return 'danger'
    return 'primary'
  }

  return {
    findAllTabelaPreco,
    tableColumns,
    perPage,
    currentPage,
    totalTabelaPreco,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTabelaPrecoItemTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    idTabelaPrecoFilter,
  }
}
